const ua = window.navigator.userAgent.toLowerCase();
const videoExtensions = ['mp4', 'wmv', 'avi', 'mov'];

export function isIPhoneX() {
  return /iphone/gi.test(ua) && (window.screen.height / window.screen.width) > 2;
}
export function isWeixin() {
  console.log('ua', ua);
  // eslint-disable-next-line eqeqeq
  return ua.match(/MicroMessenger/i) == 'micromessenger';
}
export function isQYWeixin() {
  console.log('ua', ua);
  // eslint-disable-next-line eqeqeq
  return isWeixin() && (ua.match(/wxwork/i) == 'wxwork');
}

export function checkVideo(url) {
  if (!url) return false;
  const arr = url.split('.');
  const extension = arr[arr.length - 1];
  if (!extension) {
    return false;
  }
  return videoExtensions.includes(extension.toLowerCase());
}